import { slidesData } from '../common/interfaces/slide';
import { get } from './utility/Requests.default';

export const carouselURL = '/api/content/carousel/getCarouselCMSData';

export async function getContentfulResource() {
    return get<slidesData>(carouselURL);
}
